import React, { useContext, useEffect, useState } from 'react'
import EyeIcon from '../../../assets/eye-black-icon.svg'
import AddIcon from '../../../assets/addnew-icon2.svg'
import EditIcon from '../../../assets/edit-svg-black.svg'
import useAxios from 'axios-hooks'
import { LIVE_STREAM_API, LIVE_STREAM_FILTER_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import LiveStreamCreateModal from './liveStreamCreateModal'
import { checkPermissions, raiseToast } from '../../utils/helper'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { GlobalContext } from 'src/views/context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { CButton, CCard } from '@coreui/react'
import AssetFilter from '../AssetManager/AssetFilter'
import FormListCard from '../customForms/formListCard'
import moment from 'moment'
import LiveStreamOBSInfoModal from './liveStreamOBSInfoModal'
import ReviewLiveStreamModal from './reviewLiveStreamModal'
import { PAGE_SIZE } from 'src/views/utils/constants'
import InfiniteScroll from 'react-infinite-scroll-component'

const LiveStreamListing = () => {
  const [liveStreamData, setLiveStreamData] = useState([])
  const [page, setPage] = useState(1)
  const [openModal, setOpenModal] = useState(0)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [location, setLocation] = useState('US East (Ohio)')
  const [recording, setRecording] = useState(false)
  const { setLoader, accountObj } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [searchText, setSearchText] = useState('')
  const [selectedLiveStream, setSelectedLiveStream] = useState({})
  const [filterPayloadObj, setFilterPayloadObj] = useState({})
  const [recordFilter, setRecordFilter] = useState(null)
  const [statusFilter, setStatusFilter] = useState(null)

  const language = localStorage.getItem('language')
  const defaultLangCheck = language === accountObj?.default_language

  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.LIVE.CREATE) &&
    defaultLangCheck
  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.LIVE.UPDATE,
  )
  const history = useHistory()

  const filterIntialValue = [
    {
      title: 'Status',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'ONLINE', value: 'online' },
        { name: 'OFFLINE', value: 'offline' },
      ],
      onSelect: (value) => {
        setStatusFilter(value ? value : null)
        handleFilterChange(0, value)
      },
    },
    {
      title: 'Recording',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled' },
      ],
      onSelect: (value) => {
        setRecordFilter(value ? value : null)
        handleFilterChange(1, value)
      },
    },
  ]
  const [filters, setFilters] = useState(filterIntialValue)

  const handleFilterChange = (index, value) => {
    // debugger
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }

  const [{ data: liveStreamList, loading: liveStreamLoading }, liveStreamListCall] = useAxios(
    {
      url: LIVE_STREAM_FILTER_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: liveStreamCreate, loading: liveStreamCreateLoading }, createLiveStreamCall] =
    useAxios(
      {
        url: LIVE_STREAM_API,
        method: 'post',
      },
      { manual: true },
    )

  const [{ data: liveStreamUpdate, loading: liveStreamUpdateLoading }, updateLiveStreamCall] =
    useAxios(
      {
        url: LIVE_STREAM_API,
        method: 'put',
      },
      { manual: true },
    )

  useEffect(() => {
    let obj = {}

    if (recordFilter !== null) {
      obj['to_record'] = recordFilter === 'enabled'
    }
    if (statusFilter !== null) {
      obj['in_progress'] = statusFilter === 'online'
    }
    if (searchText) {
      obj['search_text'] = searchText
    }
    setFilterPayloadObj({ ...obj })
  }, [searchText, recordFilter, statusFilter])

  useEffect(() => {
    liveStreamListCall({
      data: {
        filters: filterPayloadObj,
        page: page,
        order_by: 'modified_date',
        reverse: true,
        page_size: PAGE_SIZE,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(liveStreamLoading || liveStreamCreateLoading || liveStreamUpdateLoading)
  }, [liveStreamLoading, liveStreamCreateLoading, liveStreamUpdateLoading])

  useEffect(() => {
    if (liveStreamList && liveStreamList.success) {
      page === 1
        ? setLiveStreamData(liveStreamList.data)
        : setLiveStreamData((liveStreamData) => [...liveStreamData, ...liveStreamList.data])
    }
  }, [liveStreamList])

  useEffect(() => {
    if (liveStreamCreate && liveStreamCreate.success) {
      history.push(`/live-detail/${liveStreamCreate?.data?.live_stream_id}`)
      raiseToast('success', 'Live Stream created successfully')
    }
  }, [liveStreamCreate])

  useEffect(() => {
    if (liveStreamUpdate && liveStreamUpdate.success) {
      liveStreamListCall({
        data: {
          filters: filterPayloadObj,
          page: page,
          order_by: 'modified_date',
          reverse: true,
          page_size: PAGE_SIZE,
        },
      })
      raiseToast('success', 'Live Stream updated successfully')
    }
  }, [liveStreamUpdate])

  useEffect(() => {
    if (!isEmpty(selectedLiveStream)) {
      setName(selectedLiveStream.name)
      setDescription(selectedLiveStream.description)
      setRecording(selectedLiveStream.to_record)
    }
  }, [selectedLiveStream])

  const handleAdd = () => {
    setOpenModal(1)
  }

  const addLiveStream = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    createLiveStreamCall({
      data: {
        name: name,
        description: description,
        to_record: recording,
      },
    })
    setOpenModal(0)
    setName('')
    setDescription('')
    setRecording('')
  }

  const editLiveStream = () => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    updateLiveStreamCall({
      params: {
        stream_id: selectedLiveStream._id,
      },
      data: {
        name: name,
        description: description,
        to_record: recording,
      },
    })
    setOpenModal(0)
    setSelectedLiveStream({})
    setName('')
    setDescription('')
    setRecording('')
  }

  const handleDetailPage = (info) => {
    history.push(`/live-detail/${info._id}`)
  }

  const handleNextPage = () => {
    liveStreamListCall({
      data: {
        filters: filterPayloadObj,
        page: page + 1,
        order_by: 'modified_date',
        reverse: true,
        page_size: PAGE_SIZE,
      },
    })
    setPage((page) => page + 1)
  }

  const applyFilter = () => {
    setPage(1)
    liveStreamListCall({
      data: {
        filters: filterPayloadObj,
        page: 1,
        order_by: 'modified_date',
        reverse: true,
        page_size: PAGE_SIZE,
      },
    })
  }

  const resetFilters = () => {
    setRecordFilter(null)
    setStatusFilter(null)
    setPage(1)
    setFilters(filterIntialValue)
    liveStreamListCall({
      data: {
        filters: { search_text: searchText },
        page: 1,
        order_by: 'modified_date',
        reverse: true,
        page_size: PAGE_SIZE,
      },
    })
  }

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    liveStreamListCall({
      data: {
        filters: { ...filterPayloadObj, search_text: value },
        page: page,
        order_by: 'modified_date',
        reverse: true,
        page_size: PAGE_SIZE,
      },
    })
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>LIVE Studio</h4>
          <p>Following are the Live Streams which are already in your store.</p>
        </div>
        <CButton
          className="text-white px-3"
          onClick={handleAdd}
          disabled={!isCreateAllowed}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
          title={defaultLangCheck ? '' : 'Adding Content Available on Default Language'}
        >
          + Add Live Stream
        </CButton>
      </div>
      <CCard style={{ height: '70vh' }}>
        <div className="d-flex justify-content-center py-4 position-relative w-100">
          <div className="">
            <AssetFilter
              filters={filters}
              onSearch={handleSearch}
              onApply={applyFilter}
              onClearAll={resetFilters}
              dropdownHeight={'250px'}
              dropdownTopValue={'0vh'}
            />
          </div>
        </div>
        <div id="scrollableDiv" className="px-2">
          <InfiniteScroll
            dataLength={liveStreamData.length} //This is important field to render the next data
            next={handleNextPage}
            hasMore={liveStreamList && liveStreamList.total > page * PAGE_SIZE}
            style={{ overflowX: 'hidden' }}
            loader={<p>Loading...</p>}
            className="custom-scrollbar-vertical "
            height={`60vh`}
            scrollableTarget="scrollableDiv"
          >
            <div
              className="d-flex px-3 justify-content-center align-items-center w-100 bg-black text-white position-"
              style={{
                fontSize: 'max(0.63vw,10px)',
                // gap: '0 2.2%',
                paddingTop: '2px',
                paddingBottom: '2px ',
                top: '0',
                zIndex: '1',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
                position: 'sticky',
              }}
            >
              <div className="d-flex align-items-center w-100">
                <div style={{ width: '24%' }}>Live Stream Title</div>
                <div style={{ width: '26%' }}>Description</div>
                <div style={{ width: '10%' }}>Status</div>
                <div style={{ width: '11%' }}>Recording</div>
                <div style={{ width: '15%' }}>Last Updated</div>
                <div style={{ width: '9%' }} className="text-center">
                  State
                </div>
                <div style={{ width: '5%' }} />
              </div>
            </div>
            <div>
              <div
                className="d-flex flex-wrap"
                style={{
                  gap: '1vw 0',
                  padding: '10px 2px 10px 2px',
                }}
              >
                {!isEmpty(liveStreamData) ? (
                  liveStreamData.map((info, index) => {
                    return (
                      <FormListCard
                        disableCardImg={true}
                        cardOnClick={() => {
                          handleDetailPage(info)
                        }}
                        cardClass="px-3"
                        cardImgWidth="0%"
                        // cardStyle={{ paddingLeft: '3px', paddingRight: '3px', cursor: 'pointer' }}
                        disableStatus={true}
                        textData={[
                          {
                            name: (
                              <div className="">
                                <p className="mb-0" style={{ fontSize: '14px', fontWeight: '550' }}>
                                  {info?.name}
                                </p>
                                <p className="mb-0" style={{ color: '#6a6a6a', fontSize: '12px' }}>
                                  ID: {info?.stream_key}
                                </p>
                              </div>
                            ),
                            styles: { width: '24.1%' },
                          },
                          {
                            name: info?.description,
                            styles: { width: '25.9%' },
                          },
                          {
                            name: info.in_progress ? 'LIVE' : 'OFFLINE',
                            styles: { width: '10%' },
                          },
                          {
                            name: info.to_record ? 'ENABLED' : 'DISABLED',
                            styles: { width: '11%' },
                          },
                          {
                            name: moment(info?.modified_date).format('DD MMM YYYY'),
                            styles: { width: '15%' },
                          },
                          {
                            name: info.in_progress ? (
                              <div
                                style={{ width: '16px', height: '16px', background: '#079549' }}
                                className="rounded-full"
                              />
                            ) : (
                              <div
                                style={{ width: '16px', height: '16px', background: '#d80000' }}
                                className="rounded-full"
                              />
                            ),
                            styles: { width: '9%', display: 'flex', justifyContent: 'center' },
                          },
                        ]}
                        key={index}
                        actionButtonOptions={[
                          {
                            name: 'View Details',
                            btnFunction: () => {
                              handleDetailPage(info)
                            },
                            logo: (
                              <div className="flex mr-1">
                                <img style={{ width: '10px' }} src={EyeIcon} />
                              </div>
                            ),
                          },
                          {
                            name: 'Edit',
                            btnFunction: () => {
                              setSelectedLiveStream(info)
                              setOpenModal(2)
                            },
                            logo: (
                              <div className="flex mr-1">
                                <img style={{ width: '10px' }} src={EditIcon} />
                              </div>
                            ),
                          },
                        ]}
                        actionButtonWidth="5%"
                      />
                    )
                  })
                ) : (
                  <p className="text-center mb-0 w-100">
                    {!liveStreamLoading && `No Live Stream data available`}
                  </p>
                )}
                {isCreateAllowed && (
                  <div
                    style={{
                      width: '100%',
                      aspectRatio: '1506/71',
                      boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                      background: '#ececec',
                      fontSize: '0.833vw',
                      fontWeight: 550,
                    }}
                    className={`rounded-1 cursor-pointer d-flex flex-col justify-content-center align-items-center`}
                    onClick={handleAdd}
                  >
                    <img
                      src={AddIcon}
                      alt="AddIcon"
                      className=""
                      style={{ width: '1.25vw', height: '1.25vw' }}
                    />
                    <span className="">Add new LIVE Stream</span>
                  </div>
                )}
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </CCard>
      {openModal === 1 && (
        <LiveStreamOBSInfoModal
          onNext={() => {
            setOpenModal(2)
          }}
        />
      )}
      {openModal === 2 && (
        <LiveStreamCreateModal
          isEdit={!isEmpty(selectedLiveStream)}
          onCancel={() => setOpenModal(0)}
          onNext={() => {
            setOpenModal(3)
          }}
          name={name}
          setName={setName}
          description={description}
          setDescription={setDescription}
          location={location}
          setLocation={setLocation}
          recording={recording}
          setRecording={setRecording}
        />
      )}
      {openModal === 3 && (
        <ReviewLiveStreamModal
          isEdit={!isEmpty(selectedLiveStream)}
          name={name}
          description={description}
          location={location}
          recording={recording}
          onBack={() => {
            setOpenModal(2)
          }}
          onSave={() => {
            isEmpty(selectedLiveStream) ? addLiveStream() : editLiveStream()
          }}
        />
      )}
    </>
  )
}

export default LiveStreamListing
